<div class="modal__content">
    <h2>{{ $t('modals.blockedregion.title') }}</h2>
    <div class="form__group">
        <p v-html="$t('modals.blockedregion.content')"></p>
    </div>
    <div class="form__group">
        <button class="btn btn-orange" @click="redirect()">{{ $t('modals.blockedregion.next') }}</button> 
    </div>
</div>
